module.exports = __webpack_public_path__ + "media/dogs/progress-bar-dog-828216fd.svg";